<template>
  <div id="lowPriceSearch" class="page-content" style="margin: 10px 20px 20px 20px;">
    <!-- <el-backtop></el-backtop> -->
    <el-breadcrumb separator="/" >
      <el-breadcrumb-item>智慧服务</el-breadcrumb-item>
      <el-breadcrumb-item>日常违规检索</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="noData" v-show="timeDataArr.length == 0" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <img src="../../../assets/img/other/nodata.svg" style="margin-top: 230px;">
      <div>
        暂无数据
      </div>
    </div>
    <div v-show="timeDataArr.length > 0" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

      <!-- <div style="width: 100%;display: flex;text-align: center;">
        <a v-for="(item,index) in timeDataArr" :key="index" @click="changeHash('#tz' + index)" class="aStyle">{{item.date}}</a>
      </div> -->
      <div v-for="(item,index) in timeDataArr" :key="index">
        <div style="display: flex;">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 10px;margin-top: 10px;">
            <div class="iconDiv">
              .
            </div>
            <div style="font-size: 18px;" :id="'tz' + index">
              {{item.date}}
            </div>
            <div style="margin-top: 4px;margin-left: 20px;font-size: 14px;">
              共计检索违规链接 {{item.totalCount}} 条
            </div>
          </div>
        </div>
        <LowModule ref="LowModuleChild" :LowModuleData="timeDataArr[index].listData" @delLowModule="getLowPriceDate"></LowModule>
      </div>
    </div>
  </div>

</template>

<script>
  import LowModule from './LowModule'
  export default {
    data(){
      return{
        timeDataArr: [],
        loading: false,
      }
    },
    filters: {
      dateDelet: function (value) {
        let s;
        s = value
　　　　 return s.substring(0,s.length-2)
　　　 },
　　},
    mounted() {
      this.getLowPriceDate()
    },
    methods:{
      // changeHash(idName) {
      //   document.querySelector(idName).scrollIntoView(true);
      // },

      // 数据源
      getLowPriceDate() {
        this.loading = true
        fetch({
          url: "hcm/iprPluginList/getLowPriceDate",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.timeDataArr = data
            this.loading = false
          } else {
            this.$message.error(res.message);
            this.loading = false
          }
        })
      },
    },
    components: {
      LowModule
    }
  }
</script>

<style lang="scss">
#lowPriceSearch {
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .el-dialog__title {
      font-size: 14px;
    }
  }
  .noData {
    width: calc(100% - 40px);
    text-align: center;
    background-color: white;
    padding: 20px;
    color: #999;
    height: 500px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #bda571;
    background: #bda571;
  }
  .el-radio__input.is-checked+.el-radio__label {
    color: #666;
  }
  .el-radio__inner:hover {
    border-color: #bda571;
  }
  .page {
    // padding: 20px;
    // margin-top: 10px;
    // background-color: #fff!important;
    height: 100%;
  }
  .aStyle {
    border: 1px solid #e5e9f2;
    width: 14.2%;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
  }
  .iconDiv {
    width: 5px;
    background-color: #333333;
    margin-right: 10px;
    height: 21px;
    margin-top: 4px;
  }
}
</style>
